import React from 'react';

import { Title as MetaTitle } from 'src/shared/components/Meta';
import { useMode, useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';

const DesignStudioTitle = () => {
  const t = useTranslate(TranslationNamespace.DESIGN_STUDIO);
  const mode = useMode();
  return <MetaTitle overwrite title={t(`meta.title.${mode}`)} />;
};

export { DesignStudioTitle };
